import React, { Component } from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { withStateHandlers } from 'recompose';
import {
  Modal,
} from 'react-bootstrap';
import TicketNumberDetailsForm from './TicketNumberDetailsForm';

export const editTicketNumberDetailsModalPropTypes = {
  showModal: PropTypes.bool.isRequired,
  openModal: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
};

export const withEditTicketNumberDetailsModalState = withStateHandlers(
  (props) => { return { showModal: false }; },
  {
    openModal: (state, props) => {
      return () => { return { showModal: true }; };
    },
    closeModal: (state, props) => {
      return () => { return { showModal: false }; };
    },
  },
);

const propTypes = exact({
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  formData: PropTypes.object.isRequired,
});

/* eslint-disable react/prefer-stateless-function */
export class EditTicketNumberDetailsModal extends Component {
  render() {
    const {
      show,
      onHide,
      formData,
    } = this.props;

    return (
      <Modal show={show} onHide={onHide}>
        <Modal.Header closeButton>
          <Modal.Title>Edit Details Form</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <TicketNumberDetailsForm
            onHide={onHide}
            initialValues={{ ...formData }}
          />
        </Modal.Body>
      </Modal>
    );
  }
}
/* eslint-enable react/prefer-stateless-function */
EditTicketNumberDetailsModal.propTypes = propTypes;

export default EditTicketNumberDetailsModal;
